import { Route } from "react-router-dom";
import DefaultLayout from "layouts/DefaultLayout";
import RequireAuth, { RequireLessonProvider } from "routes/PrivateRouter";
import { privateRouteDefs } from "routes/index";

// meta 기준 3단 분리.
//  - 공개        : 홈/목록/상세/검색 (열람)
//  - 체험(guest) : 비회원도 '작성까지' 허용. 제출 시점에 useSubmitGate 가 가입 유도.
//                  광고 유입 전환용(docs/guest-funnel-plan.md).
//  - 보호(auth)  : 내 데이터·개인정보 화면 → RequireAuth
//
// ⚠️ guest 는 auth 를 '해제'하는 플래그다. 로그인 회원은 어느 쪽이든 그대로 통과하므로
//    기존 회원 동작에는 변화가 없다.
const isProtected = (r) => !!r.meta?.auth && !r.meta?.guest;
const publicDefs = privateRouteDefs.filter((r) => !isProtected(r));
const protectedDefs = privateRouteDefs.filter(isProtected);
// 레슨 제공자(강사·학원 원장) 전용 — 로그인 가드 안에서 활성유형을 한 번 더 본다(2026-09-26 무용수 제외).
const isLessonProvider = (r) => !!r.meta?.lessonProvider;

const PrivateRoutes = (
  <Route element={<DefaultLayout />}>
    {publicDefs.map((r) => (
      <Route key={r.path} path={r.path} element={r.element} />
    ))}

    <Route element={<RequireAuth />}>
      {protectedDefs.filter((r) => !isLessonProvider(r)).map((r) => (
        <Route key={r.path} path={r.path} element={r.element} />
      ))}
      <Route element={<RequireLessonProvider />}>
        {protectedDefs.filter(isLessonProvider).map((r) => (
          <Route key={r.path} path={r.path} element={r.element} />
        ))}
      </Route>
    </Route>
  </Route>
);

export default PrivateRoutes;
